/// <amd-module name="SuiteCommerce.StockNotifications.Common.InstrumentationHelper"/>
define("SuiteCommerce.StockNotifications.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.StockNotifications.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InstrumentationHelper = void 0;
    var QueueNameSuffix = '-StockNotifications';
    var ExtensionVersion = '1.1.9';
    var ComponentArea = 'SC Stock Notifications';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                },
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
